import { Pipe, PipeTransform, ɵConsole } from '@angular/core';
import * as _ from 'underscore';
@Pipe({
    name: 'groupBy',
    standalone: false
})
export class GroupbyPipe implements PipeTransform {
    array:any =[]=[];
  transform(collection: any, property: string): any {
//    console.log(property.length,property[1])
//    if(property.length>1){
//     if (!collection) {
//         return null;
//     }
//     const groupedCollection = collection.reduce((previous, current) => {
//         if (!previous[current[property[0]]]) {
//             previous[current[property[0]]] = [current];
//         } else {
//             previous[current[property[0]]].push(current);
//         }

//         return previous;
//     }, {});
//     const data= Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] })); 

//     const dataKeys = _.allKeys(data);
//         dataKeys.forEach(element => {
//     const secondGroupData= data[element].value.reduce((pr, current) => {
//                 if (!pr[current[property[1]]]) {
//                     pr[current[property[1]]] = [current];
//                 } else {
//                     pr[current[property[1]]].push(current);
//                 }
        
//                 return pr;
//             }, {});
            
//             const data1= Object.keys(secondGroupData).map(key => ({ key, value: secondGroupData[key] }));
           

//             console.log(data1)
//             return data1;
//         });

   

//    }
// else{
    if (!collection) {
        return null;
    }
    const groupedCollection = collection.reduce((previous, current) => {
        if (!previous[current[property]]) {
            previous[current[property]] = [current];
        } else {
            previous[current[property]].push(current);
        }

        return previous;
    }, {});
    // console.log(groupedCollection)
    return Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] })); 
// }
   



    
}

}
